/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { BandoTransazioniSelectDTO } from '../model/bando-transazioni-select-dto';
// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { NegozioPosDTO } from '../model/negozio-pos-dto';
// @ts-ignore
import { Pageable } from '../model/pageable';
// @ts-ignore
import { PagedModelTransazioneVoucherListItemDTO } from '../model/paged-model-transazione-voucher-list-item-dto';
// @ts-ignore
import { TransazioneVoucherArticoliBatchForm } from '../model/transazione-voucher-articoli-batch-form';
// @ts-ignore
import { TransazioneVoucherArticoloSpendForm } from '../model/transazione-voucher-articolo-spend-form';
// @ts-ignore
import { TransazioneVoucherListFilter } from '../model/transazione-voucher-list-filter';
// @ts-ignore
import { TransazioneVoucherSpendForm } from '../model/transazione-voucher-spend-form';
// @ts-ignore
import { TransazioneVoucherSpendResponseDTO } from '../model/transazione-voucher-spend-response-dto';
// @ts-ignore
import { TransazioneVoucherStatsDTO } from '../model/transazione-voucher-stats-dto';
// @ts-ignore
import { VoucherArticoloDTO } from '../model/voucher-articolo-dto';
// @ts-ignore
import { VoucherCheckPreviewDTO } from '../model/voucher-check-preview-dto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    EsercenteTransazioniVoucherPOSServiceInterface,
    CheckArticoliVoucherTransazionePosRequestParams,
    CheckVoucherTransazionePosRequestParams,
    GetTransazioniPosStatsRequestParams,
    ListBandiPosRequestParams,
    ListTransazioniPosRequestParams,
    SpendArticoliTransazionePosRequestParams,
    SpendArticoloTransazionePosRequestParams,
    SpendTransazionePosRequestParams
} from './esercente-transazioni-voucher-pos.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class EsercenteTransazioniVoucherPOSService extends BaseService implements EsercenteTransazioniVoucherPOSServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Elenca gli articoli di un voucher cedole (checkarticoli).
     * Risolve il voucher (scope-first anti-IDOR) e ne elenca gli articoli con lo stato corrente (DA_PRENOTARE_O_RITIRARE/PRENOTATO/RITIRATO), senza mutazioni. Voucher CONSUMATO consultabile; ANNULLATO → 422; contributo-mode (nessun articolo) → 422; CF→più voucher → 409. Materializza idempotente i voucher emessi prima della change.
     * @endpoint get /api/v1/esercente/transazioni-voucher/voucher/{codice}/articoli
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public checkArticoliVoucherTransazionePos(requestParameters: CheckArticoliVoucherTransazionePosRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<VoucherArticoloDTO>>;
    public checkArticoliVoucherTransazionePos(requestParameters: CheckArticoliVoucherTransazionePosRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<VoucherArticoloDTO>>>;
    public checkArticoliVoucherTransazionePos(requestParameters: CheckArticoliVoucherTransazionePosRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<VoucherArticoloDTO>>>;
    public checkArticoliVoucherTransazionePos(requestParameters: CheckArticoliVoucherTransazionePosRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const codice = requestParameters?.codice;
        if (codice === null || codice === undefined) {
            throw new Error('Required parameter codice was null or undefined when calling checkArticoliVoucherTransazionePos.');
        }
        const idNegozio = requestParameters?.idNegozio;
        if (idNegozio === null || idNegozio === undefined) {
            throw new Error('Required parameter idNegozio was null or undefined when calling checkArticoliVoucherTransazionePos.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'id_negozio',
            <any>idNegozio,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/esercente/transazioni-voucher/voucher/${this.configuration.encodeParam({name: "codice", value: codice, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/articoli`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<VoucherArticoloDTO>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Verifica un voucher pre-spend (preview).
     * Risolve il voucher (per codice, con scope-first anti-IDOR) e verifica lo scope+abilitazione del negozio, ritornando la preview (residuo, intestatario, scadenza, stato) senza mutazioni. Step CHECK del contratto two-phase. 404 fuori insieme/scope; 409 disambiguazione se il CF mappa a più voucher.
     * @endpoint get /api/v1/esercente/transazioni-voucher/voucher/{codice}/check
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public checkVoucherTransazionePos(requestParameters: CheckVoucherTransazionePosRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<VoucherCheckPreviewDTO>;
    public checkVoucherTransazionePos(requestParameters: CheckVoucherTransazionePosRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VoucherCheckPreviewDTO>>;
    public checkVoucherTransazionePos(requestParameters: CheckVoucherTransazionePosRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VoucherCheckPreviewDTO>>;
    public checkVoucherTransazionePos(requestParameters: CheckVoucherTransazionePosRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const codice = requestParameters?.codice;
        if (codice === null || codice === undefined) {
            throw new Error('Required parameter codice was null or undefined when calling checkVoucherTransazionePos.');
        }
        const idNegozio = requestParameters?.idNegozio;
        if (idNegozio === null || idNegozio === undefined) {
            throw new Error('Required parameter idNegozio was null or undefined when calling checkVoucherTransazionePos.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'id_negozio',
            <any>idNegozio,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/esercente/transazioni-voucher/voucher/${this.configuration.encodeParam({name: "codice", value: codice, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/check`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<VoucherCheckPreviewDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Statistiche incasso del punto vendita.
     * Totale incassato (somma degli incassi: REGOLARE ed ERRATA_CORRIGE, escluse prenotazioni e annullate) + numero transazioni, scopate ai negozi del caller. Filtri opzionali id_negozio (se fuori scope i dati di quel negozio non sono esposti: totali a zero), id_tipo_pratica (bando del voucher) e tipo_transazione, gli stessi della lista: con un tipo che non è un incasso (PRENOTAZIONE, ANNULLATA) i totali sono a zero.
     * @endpoint get /api/v1/esercente/transazioni-voucher/stats
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getTransazioniPosStats(requestParameters: GetTransazioniPosStatsRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TransazioneVoucherStatsDTO>;
    public getTransazioniPosStats(requestParameters: GetTransazioniPosStatsRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TransazioneVoucherStatsDTO>>;
    public getTransazioniPosStats(requestParameters: GetTransazioniPosStatsRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TransazioneVoucherStatsDTO>>;
    public getTransazioniPosStats(requestParameters: GetTransazioniPosStatsRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const filter = requestParameters?.filter;
        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling getTransazioniPosStats.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'filter',
            <any>filter,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/esercente/transazioni-voucher/stats`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TransazioneVoucherStatsDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Elenca i bandi su cui si è transato.
     * Bandi dei voucher incassati dai negozi nello scope del caller, per il filtro «Bando» dello storico: il più recente in cima, nessuno escluso per età. Filtro opzionale id_negozio: solo i bandi di quel negozio (fuori scope → lista vuota).
     * @endpoint get /api/v1/esercente/transazioni-voucher/bandi
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listBandiPos(requestParameters?: ListBandiPosRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<BandoTransazioniSelectDTO>>;
    public listBandiPos(requestParameters?: ListBandiPosRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<BandoTransazioniSelectDTO>>>;
    public listBandiPos(requestParameters?: ListBandiPosRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<BandoTransazioniSelectDTO>>>;
    public listBandiPos(requestParameters?: ListBandiPosRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idNegozio = requestParameters?.idNegozio;

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'id_negozio',
            <any>idNegozio,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/esercente/transazioni-voucher/bandi`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<BandoTransazioniSelectDTO>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Elenca i negozi operabili al POS dal caller (scope).
     * Lista piatta dei negozi nello scope del caller (cassiere → negozi assegnati; esercente titolare → negozi posseduti del proprio profilo), ordinati per nome. Serve a popolare il selettore negozio del POS (bootstrap del cassiere nuovo, che non ha ancora transazioni) e quello dello storico. Ogni riga {id, nome, indirizzo, abilitato_ad_almeno_un_bando}: il flag dice se il negozio ha almeno un\&#39;abilitazione formale (domanda ABILITATA, stesso criterio del check, stato del bando escluso); l\&#39;abilitazione per-(bando, negozio) resta verificata al check/spend. Caller senza negozi → [].
     * @endpoint get /api/v1/esercente/transazioni-voucher/negozi
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listNegoziPos(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<NegozioPosDTO>>;
    public listNegoziPos(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<NegozioPosDTO>>>;
    public listNegoziPos(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<NegozioPosDTO>>>;
    public listNegoziPos(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/esercente/transazioni-voucher/negozi`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<NegozioPosDTO>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Elenca le proprie transazioni POS.
     * Page delle transazioni limitate ai negozi nello scope del caller (cassiere/esercente titolare), ordinate per data DESC. Filtri opzionali id_negozio, id_tipo_pratica (bando del voucher) e tipo_transazione: restringono dentro lo scope, mai lo allargano.
     * @endpoint get /api/v1/esercente/transazioni-voucher
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listTransazioniPos(requestParameters: ListTransazioniPosRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedModelTransazioneVoucherListItemDTO>;
    public listTransazioniPos(requestParameters: ListTransazioniPosRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedModelTransazioneVoucherListItemDTO>>;
    public listTransazioniPos(requestParameters: ListTransazioniPosRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedModelTransazioneVoucherListItemDTO>>;
    public listTransazioniPos(requestParameters: ListTransazioniPosRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const filter = requestParameters?.filter;
        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling listTransazioniPos.');
        }
        const pageable = requestParameters?.pageable;
        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling listTransazioniPos.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'filter',
            <any>filter,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'pageable',
            <any>pageable,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/esercente/transazioni-voucher`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedModelTransazioneVoucherListItemDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Prenota o consegna più articoli in uno scontrino (batch all-or-nothing).
     * Consuma più istanze articolo in un solo scontrino, ciascuna con la propria version. Se anche una sola non è idonea l\&#39;intero scontrino è rifiutato (422) e nulla è persistito (all-or-nothing). Nessun decremento del residuo.
     * @endpoint post /api/v1/esercente/transazioni-voucher/articoli
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public spendArticoliTransazionePos(requestParameters: SpendArticoliTransazionePosRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public spendArticoliTransazionePos(requestParameters: SpendArticoliTransazionePosRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public spendArticoliTransazionePos(requestParameters: SpendArticoliTransazionePosRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public spendArticoliTransazionePos(requestParameters: SpendArticoliTransazionePosRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const transazioneVoucherArticoliBatchForm = requestParameters?.transazioneVoucherArticoliBatchForm;
        if (transazioneVoucherArticoliBatchForm === null || transazioneVoucherArticoliBatchForm === undefined) {
            throw new Error('Required parameter transazioneVoucherArticoliBatchForm was null or undefined when calling spendArticoliTransazionePos.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/esercente/transazioni-voucher/articoli`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: transazioneVoucherArticoliBatchForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Prenota o consegna un articolo di un voucher cedole.
     * PRENOTAZIONE (istanza → PRENOTATO, transazione a valore 0) o CONSEGNA (istanza → RITIRATO, transazione col valore frozen del libro). Nessun decremento del residuo (chiusura article-driven). Richiede la version dell\&#39;istanza articolo (409 se stale). 404 voucher/articolo fuori scope; 422 negozio non abilitato/articolo già ritirato/contributo-mode/stato.
     * @endpoint post /api/v1/esercente/transazioni-voucher/articolo
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public spendArticoloTransazionePos(requestParameters: SpendArticoloTransazionePosRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public spendArticoloTransazionePos(requestParameters: SpendArticoloTransazionePosRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public spendArticoloTransazionePos(requestParameters: SpendArticoloTransazionePosRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public spendArticoloTransazionePos(requestParameters: SpendArticoloTransazionePosRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const transazioneVoucherArticoloSpendForm = requestParameters?.transazioneVoucherArticoloSpendForm;
        if (transazioneVoucherArticoloSpendForm === null || transazioneVoucherArticoloSpendForm === undefined) {
            throw new Error('Required parameter transazioneVoucherArticoloSpendForm was null or undefined when calling spendArticoloTransazionePos.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/esercente/transazioni-voucher/articolo`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: transazioneVoucherArticoloSpendForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consuma importo da un voucher al POS.
     * Crea una transazione REGOLARE, decrementa il residuo del voucher e lo porta a PARZIALMENTE_CONSUMATO (residuo &gt; 0) o CONSUMATO (residuo 0). Richiede la version del voucher (contratto @Version→409 col residuo corrente). 404 voucher fuori insieme/negozio fuori scope; 422 negozio non abilitato/importo/residuo/stato/scadenza; 409 version stale.
     * @endpoint post /api/v1/esercente/transazioni-voucher
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public spendTransazionePos(requestParameters: SpendTransazionePosRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TransazioneVoucherSpendResponseDTO>;
    public spendTransazionePos(requestParameters: SpendTransazionePosRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TransazioneVoucherSpendResponseDTO>>;
    public spendTransazionePos(requestParameters: SpendTransazionePosRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TransazioneVoucherSpendResponseDTO>>;
    public spendTransazionePos(requestParameters: SpendTransazionePosRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const transazioneVoucherSpendForm = requestParameters?.transazioneVoucherSpendForm;
        if (transazioneVoucherSpendForm === null || transazioneVoucherSpendForm === undefined) {
            throw new Error('Required parameter transazioneVoucherSpendForm was null or undefined when calling spendTransazionePos.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/esercente/transazioni-voucher`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TransazioneVoucherSpendResponseDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: transazioneVoucherSpendForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
